import { SHOW_LOADING } from "./actionTypes";

const showLoading = (value) => ({
    type: SHOW_LOADING,
    payload: value
});

export { showLoading }